:host {
  --aha-radio-button-group--background-color: var(--theme-tertiary-background);
  --aha-radio-button-group--border-color: var(--theme-button-border);
  --aha-radio-button-group--padding: 2px;

  /* Ensure that pseudo-button has the same border radius and other styles as nested buttons.  */
  --aha-radio-button--top-left-border-radius: var(--Common--border-radius);
  --aha-radio-button--top-right-border-radius: var(--Common--border-radius);
  --aha-radio-button--bottom-right-border-radius: var(--Common--border-radius);
  --aha-radio-button--bottom-left-border-radius: var(--Common--border-radius);
  --aha-radio-button--border-radius: var(--aha-radio-button--top-left-border-radius)
    var(--aha-radio-button--top-right-border-radius)
    var(--aha-radio-button--bottom-right-border-radius)
    var(--aha-radio-button--bottom-left-border-radius);

  --aha-radio-button-group--top-left-border-radius: var(--aha-radio-button--top-left-border-radius);
  --aha-radio-button-group--top-right-border-radius: var(
    --aha-radio-button--top-right-border-radius
  );
  --aha-radio-button-group--bottom-right-border-radius: var(
    --aha-radio-button--bottom-right-border-radius
  );
  --aha-radio-button-group--bottom-left-border-radius: var(
    --aha-radio-button--bottom-left-border-radius
  );
  --aha-radio-button-group--border-radius: var(--aha-radio-button-group--top-left-border-radius)
    var(--aha-radio-button-group--top-right-border-radius)
    var(--aha-radio-button-group--bottom-right-border-radius)
    var(--aha-radio-button-group--bottom-left-border-radius);

  --aha-radio-button--background-selected: var(--theme-primary-background);
  --aha-radio-button--selected-transition-time: 0.2s;

  box-sizing: border-box;
  display: inline-flex;
  position: relative;
}
:host([flavor='blue']) {
  --aha-radio-button-group--background-color: var(--theme-blue-background);
  --aha-radio-button-group--border-color: var(--theme-blue-border);
}

:host([first-render]) {
  --aha-radio-button--selected-transition-time: 0s;
}
#content {
  box-sizing: inherit;
  display: inline-flex;

  align-items: stretch;
  gap: var(--spacer-1);
  background-color: var(--aha-radio-button-group--background-color);
  border: 1px solid var(--aha-radio-button-group--border-color);
  border-radius: var(--aha-radio-button-group--border-radius);
  padding: var(--aha-radio-button-group--padding);
}
#pseudo-button {
  position: absolute;
  background: var(--aha-radio-button--background-selected);
  transition: all var(--aha-radio-button--selected-transition-time)
    cubic-bezier(0.39, 0.58, 0.57, 1);
  border-radius: var(--aha-radio-button--border-radius);
  box-shadow: var(--theme-shadow-shallow);
}

@media (prefers-reduced-motion) {
  :host {
    --aha-radio-button--selected-transition-time: 0s;
  }
}
